function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import { PropTypes } from 'prop-types';
import { useDropzone } from 'react-dropzone';
import { Icon } from '@unite-us/ui';
import { generateUUID } from '../../utils/utils';
import FilePreviewWrapper from './components/FilePreviewWrapper';
import './stylesheets/FileUpload.scss';
var ACCEPTED_FILE_TYPES = "text/csv, application/msword,\napplication/vnd.openxmlformats-officedocument.wordprocessingml.document,\napplication/pdf, application/rtf, text/rtf, application/x-rtf, text/plain,\napplication/excel, application/vnd.ms-excel, application/x-excel, application/x-msexcel,\napplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\napplication/vnd.ms-excel.sheet.binary.macroEnabled.12,\napplication/vnd.ms-excel,\napplication/vnd.ms-excel.sheet.macroEnabled.12,\nimage/gif, image/jpg, image/jpeg, image/png, audio/mpeg, audio/m4a,\naudio/x-m4a, audio/wav, audio/x-wav, audio/x-ms-wma, video/x-ms-wma";
var MAX_FILE_SIZE = 10000000;
export var FileUpload = function FileUpload(_ref) {
  var rejectedFiles = _ref.rejectedFiles,
    uploadedFiles = _ref.uploadedFiles,
    setRejectedFiles = _ref.setRejectedFiles,
    setUploadedFiles = _ref.setUploadedFiles;
  var onDrop = function onDrop(acceptedFiles) {
    var fileUploadWithIdAndPreview = acceptedFiles.map(function (file) {
      return {
        file: file,
        tempId: generateUUID(),
        preview: URL.createObjectURL(file)
      };
    });
    setRejectedFiles({
      filesTooBig: [],
      filesWrongType: []
    });
    setUploadedFiles([].concat(_toConsumableArray(uploadedFiles), _toConsumableArray(fileUploadWithIdAndPreview)));
  };
  var onDropRejected = function onDropRejected(fileRejections) {
    var _fileRejections$reduc = fileRejections.reduce(function (acc, rejectedFile) {
        if (rejectedFile.size > MAX_FILE_SIZE && !ACCEPTED_FILE_TYPES.includes(rejectedFile.type)) {
          return _objectSpread(_objectSpread({}, acc), {}, {
            filesTooBigAndWrongType: [].concat(_toConsumableArray(acc.filesTooBigAndWrongType), [rejectedFile.name])
          });
        }
        if (rejectedFile.size > MAX_FILE_SIZE) {
          return _objectSpread(_objectSpread({}, acc), {}, {
            filesTooBig: [].concat(_toConsumableArray(acc.filesTooBig), [rejectedFile.name])
          });
        }
        if (!ACCEPTED_FILE_TYPES.includes(rejectedFile.type)) {
          return _objectSpread(_objectSpread({}, acc), {}, {
            filesWrongType: [].concat(_toConsumableArray(acc.filesWrongType), [rejectedFile.name])
          });
        }
        return acc;
      }, {
        filesTooBig: [],
        filesWrongType: [],
        filesTooBigAndWrongType: []
      }),
      filesTooBig = _fileRejections$reduc.filesTooBig,
      filesWrongType = _fileRejections$reduc.filesWrongType,
      filesTooBigAndWrongType = _fileRejections$reduc.filesTooBigAndWrongType;
    setRejectedFiles({
      filesTooBig: filesTooBig,
      filesWrongType: filesWrongType,
      filesTooBigAndWrongType: filesTooBigAndWrongType
    });
  };
  var _useDropzone = useDropzone({
      accept: ACCEPTED_FILE_TYPES,
      maxSize: MAX_FILE_SIZE,
      onDrop: onDrop,
      onDropRejected: onDropRejected
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  var _rejectedFiles$filesT = rejectedFiles.filesTooBig,
    filesTooBig = _rejectedFiles$filesT === void 0 ? [] : _rejectedFiles$filesT,
    _rejectedFiles$filesW = rejectedFiles.filesWrongType,
    filesWrongType = _rejectedFiles$filesW === void 0 ? [] : _rejectedFiles$filesW,
    _rejectedFiles$filesT2 = rejectedFiles.filesTooBigAndWrongType,
    filesTooBigAndWrongType = _rejectedFiles$filesT2 === void 0 ? [] : _rejectedFiles$filesT2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, filesTooBigAndWrongType.length ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "mr-2 text-validation-red fill-current pb-1",
    icon: 'V2Warning',
    size: 14
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: 'text-sm text-validation-red'
  }, "This file type is not supported and exceeds the maximum upload size of 10MB."), /*#__PURE__*/React.createElement("div", {
    className: 'text-sm text-validation-red mt-2'
  }, "Accepted formats are CSV .DOC .DOCX .PDF .RTF .TXT .XLS .XLSX .GIF .JPG .JPEG .PNG .MP3 .M4A .WAV .WMA"))), /*#__PURE__*/React.createElement("ul", null, filesTooBigAndWrongType.map(function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file,
      className: 'text-sm text-validation-red list-disc mt-1'
    }, file);
  }))) : null, filesWrongType.length ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(filesTooBigAndWrongType.length ? 'mt-3' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "mr-2 text-validation-red fill-current pb-1",
    icon: 'V2Warning',
    size: 14
  })), /*#__PURE__*/React.createElement("span", {
    className: 'text-sm text-validation-red'
  }, "This file type is not supported. Accepted formats are CSV .DOC .DOCX .PDF .RTF .TXT .XLS .XLSX .GIF .JPG .JPEG .PNG .MP3 .M4A .WAV .WMA")), /*#__PURE__*/React.createElement("ul", null, filesWrongType.map(function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file,
      className: 'text-sm text-validation-red list-disc mt-1'
    }, file);
  }))) : null, filesTooBig.length ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(filesWrongType.length || filesTooBigAndWrongType.length ? 'mt-3' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "mr-2 text-validation-red fill-current pb-1",
    icon: 'V2Warning',
    size: 14
  })), /*#__PURE__*/React.createElement("span", {
    className: 'text-sm text-validation-red'
  }, "The following file exceeds the maximum upload size of 10MB")), /*#__PURE__*/React.createElement("ul", null, filesTooBig.map(function (file) {
    return /*#__PURE__*/React.createElement("li", {
      key: file,
      className: 'text-sm text-validation-red list-disc mt-1'
    }, file);
  }))) : null, /*#__PURE__*/React.createElement("div", _extends({}, getRootProps(), {
    className: "file-upload-dropzone mb-3 mt-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "file-upload-dropzone__preview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    className: "mb-3 text-dark-blue",
    icon: 'V2Upload',
    size: 16,
    color: 'none'
  })), /*#__PURE__*/React.createElement("button", _extends({
    className: "mb-2 text-base text-dark-blue",
    type: "button"
  }, getRootProps(), {
    //this handles the click correctly without manipulating the DOM
    tabIndex: "0"
  }), "Drag and drop files or ", /*#__PURE__*/React.createElement("span", {
    className: "text-current-blue text-base"
  }, "Browse")), /*#__PURE__*/React.createElement("p", {
    className: "text-xs"
  }, "Supported: csv, doc, docx, pdf, rtf, txt, xls, xlsx, gif, jpg, jpeg, png, mp3, m4a, wav, wma"), /*#__PURE__*/React.createElement("p", {
    className: "text-xs"
  }, "Maximum file size: 10mb")), /*#__PURE__*/React.createElement(FilePreviewWrapper, {
    uploadedFiles: uploadedFiles
  }), /*#__PURE__*/React.createElement("input", getInputProps()))));
};
FileUpload.propTypes = {
  rejectedFiles: PropTypes.object.isRequired,
  uploadedFiles: PropTypes.array.isRequired,
  setRejectedFiles: PropTypes.func.isRequired,
  setUploadedFiles: PropTypes.func.isRequired
};
export default FileUpload;
//# sourceMappingURL=FileUpload.js.map